<template>
  <div class="pa-4 pa-md-5">
    <v-btn @click="$router.back()" class="back-btn mb-3">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>
    <v-col cols="12" class="pa-0">
      <tabla
        Titulo="Gestión de Roles"
        :Cabecera="Cabecera"
        :Items="Items"
        :Excel="true"
        :Crear="true"
        :Loading="Loading"
      />
    </v-col>
  </div>
</template>
<script>
import tabla from "@/components/roles/tabla.vue";

import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "Roles",
  components: {
    tabla,
  },

  created() {
    const data = {
      menu: 1,
      submenu: 0,
    };
    this.CargarMenu(data);
    this.cargarRoles();
  },
  data() {
    return {
      Cabecera: [
        {
          text: "Acción",
          value: "accion",
          align: "center",
          sortable: false,
          width: 100,
        },
        {
          text: "Código",
          value: "id",
          align: "center",
          width: 80,
        },
        {
          text: "Rol",
          value: "name",
          align: "left",
          width: 180,
        },
        {
          text: "Descripción",
          value: "description",
          align: "left",
        },
      ],
    };
  },
    methods: {
        ...mapActions('roles', ['cargarRoles']),
        ...mapActions('nav', ['CargarMenu'])
    },

    computed: {
        ...mapGetters('roles', ['Items']),
        ...mapState("roles", ['Loading'])
    }

};
</script>
